<form [formGroup]="form" class="flex h-full items-center px-2">
  <mat-slide-toggle
    formControlName="onlyCompanyWide"
    (change)="onChange($event)"
    >Solo listas globales</mat-slide-toggle
  >
</form>
